import { zoneLabel } from '@/shared/lib/time-zone';

import { useMarketTimeZone } from '../hooks/use-market-time-zone';

/**
 * The selected market's time zone, next to the country selector: every date and time in the
 * admin is in it unless a page says otherwise. The offset is the one in force now.
 */
export function MarketTimeIndicator() {
  const zone = useMarketTimeZone();
  return (
    <span className="text-muted-foreground hidden px-1 text-xs whitespace-nowrap sm:inline">
      {zoneLabel(zone)}
    </span>
  );
}
